import { render, staticRenderFns } from "./insuranceForm.vue?vue&type=template&id=8bc64752&scoped=true"
import script from "./insuranceForm.vue?vue&type=script&lang=js"
export * from "./insuranceForm.vue?vue&type=script&lang=js"
import style0 from "./insuranceForm.vue?vue&type=style&index=0&id=8bc64752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc64752",
  null
  
)

export default component.exports